module.exports = __webpack_public_path__ + "static/media/codecache.9b65bd37.png";